<template>
    <teleport to="#modal">
        <Loading :visible="loading"/>
    </teleport>
    <div class="max-w-screen-2xl mx-auto py-10 px-8">
        <div class="flex justify-between items-center">
            <h1 class="font-bold text-2xl mb-2">Downloads</h1>
            <NextButton @click="lista_tasks.reset()" class="px-2 py-1">Aggiorna</NextButton>
            <NextButton @click="pulisci" class="px-2 py-1">Pulisci</NextButton>
        </div>
        <Paginator class=" mb-4" :pagination="lista_tasks.paginate"></Paginator>
        <div>
            <div v-for="i in lista_tasks.rows" :key="i.id">
                <div class="bg-white p-3 mb-3">
                    <div>
                        <div class="font-bold">{{ i.title }}</div>
                        <div class="text-sm">{{ $filters.toDateTime(i.created_at) }}</div>
                        <div class="text-sm font-bold" :class="statusCss(i.status)">{{ statusDisplay(i.status) }}</div>
                    </div>

                    <template v-if="i.status === 'completed'">
                        <div v-for="file in i.specific.files" :key="file.id"
                             class="mt-3 border-2 border-next-gray-md p-2">
                            <a class="underline text-next-atp break-words cursor-pointer"
                               @click="downloadFile(i.specific?.files[0]?.id ?? 0)"
                            >
                                <span>
                                    {{ file.name }}
                                    <i class="icon icon-graffetta"></i>
                                </span>
                            </a>
                            <!-- <NextButton component="" @click="$filters.toDownloadFile(i.specific.files[0].id)" variant="primary" class="text-sm">Download</NextButton> -->
                        </div>

                    </template>
                    <!-- <template v-else-if="i.status == 'failed'">
                        <div class="mt-3 border-2 border-next-gray-md p-2">
                            <span class="text-next-stato-2">{{ i.error_message }}</span>
                        </div>
                    </template> -->
                </div>
            </div>
            <!-- <InfiniteLoading @infinite="lista_tasks.fetchNextPage" :identifier="lista_tasks.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri elementi.</div>
                    </template>
                </InfiniteLoading> -->
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import Checkbox from "@/components/Checkbox.vue";
import Radio from "@/components/Radio.vue";
import Spinner from "@/components/Spinner.vue";
import axios, {ResponseType} from 'axios';
import Loading from '@/components/Loading.vue';
import tasksManager from "../api/Tasks";
import Lista from '@/setup/ListaCerca';
import filesManager from "../api/File";
import { RouterLink } from 'vue-router';
import InfiniteLoading from "v3-infinite-loading";
import Paginator from "@/components/Paginator.vue";

@Options({
    name: 'DownloadCenter',
    components: {
        Spinner,
        Radio,
        Checkbox,
        NextButton,
        Loading,
        Paginator,
        InfiniteLoading
    },
    inject: ['downloadFile'],
    props: {
        id: [Number, String],
        titolo: String,
    }
})
export default class DownloadCenter extends Vue {
    loading = true;
    lista_tasks: any = setup(() => Lista(tasksManager, []));
    timer_id: any = null;

    pulisci() {
        tasksManager.deleteAll().then(() => {
            this.lista_tasks.reset();
        });
    }

    mounted() {
        this.lista_tasks.reset().finally(() => {
            this.loading = false;
        });
        this.timer_id = setInterval(() => {
            this.lista_tasks.reset();
        }, 5000);
    }

    beforeUnmount() {
        clearInterval(this.timer_id);
    }

    download(id: number) {
        filesManager.file(id).then((res) => {
            console.log(res);
        })
    }

    statusDisplay(status: string) {
        switch (status) {
            case 'completed':
                return 'Completato';
            case 'failed':
                return 'Fallito';
            case 'processing':
                return 'In corso';
            case 'pending':
                return 'In attesa';
            default:
                return 'In attesa';
        }
    }

    statusCss(status: string) {

        switch (status) {
            case 'completed':
                return 'text-next-bri';
            case 'failed':
                return 'text-next-stato-2';
            case 'processing':
                return 'text-next-att';
            case 'pending':
                return 'text-next-pro';
            default:
                return 'text-next-pro';
        }
    }
}
</script>
